import React, { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
    Customers as CustomersApi,
    CustomerGroups as CustomerGroupsApi
} from '../../../api/services/next';
import Transfer from "../../../components/shared/Transfer";

const CustomersInGroupTransfer = ({
    customerGroupId,
    value,
    onChange,
}) => {
    const [allCustomers, setAllCustomers] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);
    
    const loadCustomers = useCallback (async () => {
        const customers = await CustomersApi.GetCustomers({
            IsActive: true,
        });
        setAllCustomers(customers);
    }, []);

    const loadCustomersInGroup = useCallback(async (customerGroupIdToLoad) => {
        const customersInGroups = await CustomerGroupsApi.GetCustomersInGroup({id: customerGroupIdToLoad});
        setTargetKeys(customersInGroups.map((customerInGroup) => customerInGroup.CustomerId));
        onChange(customersInGroups);
    }, [onChange]);

    useEffect(() => {
        loadCustomers();
    }, [loadCustomers]);

    useEffect(() => {
        if (customerGroupId > 0) {
            loadCustomersInGroup(customerGroupId);
        } else {
            setTargetKeys([]);
            onChange([]);
        }
    }, [customerGroupId, loadCustomersInGroup, onChange]);

    useEffect(() => {
        setTargetKeys(value.map((customerInGroup) => customerInGroup.CustomerId));
    }, [value]);

    const searchSelector = useCallback((customer, searchTerm) => customer.Name?.toLowerCase().includes(searchTerm?.toLowerCase()), []);

    const handleCustomersInGroupChange = useCallback((keys) => {
        setTargetKeys(keys);
        onChange(keys.map((key) => ({
            CustomerGroupId: customerGroupId,
            CustomerId: key,
        })));
    }, [customerGroupId, onChange]);

    const keySelector = useCallback((customer) => customer.Id, []);
    const itemRender = useCallback((customer) => `${customer.Name}`, []);

    return (
        <Transfer
            items={allCustomers}
            itemKeySelector={keySelector}
            itemRender={itemRender}
            targetKeys={targetKeys}
            hasSearch
            searchSelector={searchSelector}
            hasSelectAll
            onTargetKeysChange={handleCustomersInGroupChange}
        />
    );
};

CustomersInGroupTransfer.propTypes = {
    customerGroupId: PropTypes.number.isRequired,
    value: PropTypes.arrayOf(PropTypes.shape({})),
    onChange: PropTypes.func.isRequired,
};

CustomersInGroupTransfer.defaultProps = {
    customerGroupId: 0,
    value: [],
}

export default CustomersInGroupTransfer;